import React from 'react';

const ComingSoonComponent = () => {
  return (
    <img style={{ display: 'block', marginTop: '20px', marginLeft: 'auto', marginRight: 'auto' }} src="/images/coming-soon.png" alt="Coming Soon..." />
  );
};

export default ComingSoonComponent;